import { render, staticRenderFns } from "./ExpedicaoForm.vue?vue&type=template&id=7d2731ca"
import script from "./ExpedicaoForm.vue?vue&type=script&lang=js"
export * from "./ExpedicaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports